import {employeeTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = employeeTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const employeeReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default employeeReducer;
